import moment from 'moment'

const TIME_OPTIONS = []
const date = moment().startOf('day')

for (let hour = 0; hour < 24; hour++) {
    date.hour(hour)
    TIME_OPTIONS.push({
        label: date.format('h:00 A'),
        value: date.format('H:00')
    })

    TIME_OPTIONS.push({
        label: date.format('h:30 A'),
        value: date.format('H:30')
    })
}

export { TIME_OPTIONS }